import { getDiscounts } from '../../../api/discount.js';

const BASE = 'discount :';

export const discountActionTypes = {
  loadDiscounts: `${BASE} fetch start`,
  loadDiscountsSuccess: `${BASE} fetch SUCCESS`,
  loadDiscountsFailed: `${BASE} fetch FAILED`,
};

export const loadDiscounts = ({ restaurantIds, serviceType }) => async (dispatch) => {
  dispatch({
    type: discountActionTypes.loadDiscounts,
    restaurantIds,
    serviceType,
  });
  try {
    const { data, meta } = await getDiscounts({ restaurantIds, serviceType });
    const discountMap = meta.discount_restaurant_associations.reduce((acc, association) => {
      const { discount_id, restaurant_id } = association;
      acc.set(discount_id, restaurant_id);
      return acc;
    }, new Map());
    const discounts = data.reduce((acc, discount) => {
      const restaurantId = discountMap.get(discount.id);
      if (acc[restaurantId]) {
        acc[restaurantId].push(discount);
      } else {
        acc[restaurantId] = [discount];
      }
      return acc;
    }, {});
    dispatch({
      type: discountActionTypes.loadDiscountsSuccess,
      serviceType,
      restaurantIds,
      discounts,
    });
  } catch (e) {
    dispatch({
      type: discountActionTypes.loadDiscountsFailed,
      restaurantIds,
      serviceType,
    });
  }
};
